module.exports = [
  {
    location: 'Taipei World Trade Center Exhibition, Hall 1',
    content: "Taiwan's best exhibition hall is a landmark on the nation's bussiness horizon. This showground consists of 23,450 square metes and it is divided into 4 areas with a capacity for 1,300 standard exhibition booths. When this space is not being used for one of the 25 annual Taipei International Trade Shows, it is often being used by various organizations to stage more than 60 annaul consumer and trade exhibitions.",
    info: "No.5, Sec. 5, Xinyi Rd.,<br>Xinyi Dist., Taipei City 110,<br>Taiwan(R.O.C.)<br>Tel: 886-2-27255200<br>Ext. 2261、2258、2259、2238<br>Fax: 886-2-27251305<br>E-mail: twtc@taitra.org.tw",

  }
]



// WEBPACK FOOTER //
// ./src/plugins/transportation.js